(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/react/components/button-how-to.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/react/components/button-how-to.js');

'use strict';

const Button = svs.ui.ReactButton;
const ButtonHowTo = () => React.createElement("div", {
  className: "button-wrapper"
}, React.createElement("div", {
  className: "wrapper-body"
}, React.createElement(Button, {
  block: true,
  className: "btn btn-lotto with-icon",
  href: "/lotto/spelguide",
  type: "button"
}, "Hur fungerar lotto", React.createElement("span", null, React.createElement("svg", {
  fill: "none",
  height: "25",
  viewBox: "0 0 24 25",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, React.createElement("g", {
  clipPath: "url(#clip0_3181_949)"
}, React.createElement("path", {
  d: "M1.59998 10.2758C1.59998 7.44827 3.89334 5.10096 6.77334 5.10096C7.46662 5.10096 8.10666 5.20764 8.74669 5.47441L9.43997 5.74113L9.75998 5.10096C11.2 2.3268 14.6667 1.31322 17.3867 2.7536C19.9467 4.14068 21.0667 7.18155 20 9.90232L19.7867 10.4358L20.2133 10.8093C22.9333 13.2638 23.1467 17.4778 20.6933 20.1991C19.4133 21.5857 17.6 22.3858 15.7333 22.3858H1.59998V10.2758ZM24 15.7173C24 13.5834 23.1467 11.5028 21.6533 9.95566C22.88 6.11458 20.8 2.06008 16.96 0.833082C13.8667 -0.127199 10.4533 1.04646 8.69334 3.76722C5.12002 2.70025 1.33331 4.78085 0.266625 8.35521C0.106734 8.99538 0 9.63555 0 10.2758V23.9863H15.7333C20.2667 23.9863 24 20.3052 24 15.7173ZM12.2667 16.0908C12.2667 15.2905 12.7467 14.5436 13.3867 14.1702C15.0934 13.1032 15.5734 10.8626 14.5067 9.15546C13.44 7.44827 11.2 6.96813 9.49331 8.03514C8.42667 8.72866 7.78669 9.84897 7.78669 11.1294V11.6628H9.38667V11.1294C9.38667 10.0091 10.2933 9.10207 11.4133 9.10207C12.5333 9.10207 13.44 10.009 13.44 11.1293C13.44 11.8229 13.0667 12.4631 12.48 12.8365C11.3067 13.5305 10.6133 14.757 10.6133 16.1441V16.3041H12.2133L12.2667 16.0908ZM10.4 18.9183C10.4 18.3319 10.88 17.8512 11.4667 17.8512C12.0533 17.8512 12.5333 18.3319 12.5333 18.9182C12.5333 19.5051 12.0533 19.9852 11.4667 19.9852C10.88 19.9852 10.4 19.5051 10.4 18.9183Z",
  fill: "white"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_3181_949"
}, React.createElement("rect", {
  fill: "white",
  height: "24",
  transform: "translate(0 0.501953)",
  width: "24"
}))))))));
setGlobal('svs.lotto.react.components', {
  ButtonHowTo
});

 })(window);